import type { ComponentProps } from 'react'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { staffInitials, staffPhotoSrc } from '@/lib/staff-photo'
import { cn } from '@/lib/utils'

/** A staff member's avatar: their profile photo (USA-1456), or their initials without one. */
export function StaffAvatar({
  name,
  photoUrl,
  size,
  className,
  fallbackClassName,
  children,
}: {
  name: string | null | undefined
  photoUrl?: string | null
  size?: ComponentProps<typeof Avatar>['size']
  className?: string
  fallbackClassName?: string
  /** Replaces the initials, e.g. a spinner while the assignment saves. */
  children?: React.ReactNode
}) {
  const src = staffPhotoSrc(photoUrl)
  return (
    <Avatar size={size} className={className}>
      {src ? <AvatarImage src={src} alt="" className="object-cover" /> : null}
      <AvatarFallback className={cn(fallbackClassName)}>{children ?? staffInitials(name)}</AvatarFallback>
    </Avatar>
  )
}
